import { Disclosure, DisclosurePanel } from '@headlessui/react'
import { DisclosureButton, IconBullseyeRegular } from '@smartbear/swagger-portal-component-library'
import { clsx } from 'clsx'

import { DefinitionMarkdownSubNavItem } from './DefinitionMarkdownSubNavItem'
import { InnerTagStyledDiv, NavItemStyledDiv, OuterTagStyledDiv } from '../../ApiNavItem/ApiSubNav/StyledDivs'
import { DefinitionMarkdownComponentItem } from '~/portal/types/content'

export const DefinitionMarkdownSubNav = ({
  component,
  componentItems,
  active = false,
  parentPath,
  level,
  selectedComponentItem,
  setSelectedComponentItem,
  onClick,
}: {
  component?: string,
  componentItems?: DefinitionMarkdownComponentItem[],
  active?: boolean,
  parentPath: string,
  level: number,
  selectedComponentItem?: string | null,
  setSelectedComponentItem: (selectedComponentItem: string | null) => void,
  onClick?: (e) => void,
}) => (
  <Disclosure defaultOpen>
    {({ open }) => (
      <div className="text-body3 text-(--sp-color-text-muted)">
        <OuterTagStyledDiv>
          <div className={clsx(active && 'separator h-[7px]')} />
          <InnerTagStyledDiv active={active} level={level}>
            {componentItems?.length === 0 ?
              <div
                className={clsx(
                  '-ml-1 font-normal',
                  active ? 'mb-[7px]' : 'py-[7px]',
                )}
              >
                <DefinitionMarkdownSubNavItem
                  componentItem={{
                    id: component?.toLowerCase() || '',
                    title: component || '',
                  }}
                  active={active}
                  parentPath={parentPath}
                  isSelected={selectedComponentItem === component?.toLowerCase() && active}
                  setSelectedComponentItem={setSelectedComponentItem}
                  onClick={onClick}
                  expandable={false}
                />
              </div>
              :
              <DisclosureButton
                open={open}
                className={clsx(
                  '!justify-end flex-row-reverse gap-2 px-1.5',
                  active ? 'py-0.5 mb-[7px]' : 'py-[9px]',
                )}
              >
                <span className="pr-4 text-left">{component}</span>
                <span className="pl-1 text-(--sp-color-text-muted)">
                  <IconBullseyeRegular width={12} height={12} />
                </span>
              </DisclosureButton>}
          </InnerTagStyledDiv>
        </OuterTagStyledDiv>
        <DisclosurePanel>
          {componentItems?.map((componentItem, index) => (
            <NavItemStyledDiv
              lastItem={index === componentItems.length - 1}
              index={index}
              active={active}
              level={level}
              key={componentItem.id}
              operationsLength={componentItems.length}
              isSelected={selectedComponentItem === componentItem.id && active}
            >
              <DefinitionMarkdownSubNavItem
                componentItem={componentItem}
                active={active}
                parentPath={parentPath}
                isSelected={selectedComponentItem === componentItem.id && active}
                setSelectedComponentItem={setSelectedComponentItem}
                onClick={onClick}
              />
            </NavItemStyledDiv>
          ))}
        </DisclosurePanel>
      </div>
    )}
  </Disclosure>
)
